import { DataSourceMode, Dialog, Layout } from "@mcleod/components";
import { PreassignmentPrompt } from "./PreassignmentPrompt";

export class PreassignmentDialog extends Dialog {
    private _codeType: string;
    private layout: PreassignmentPrompt;

        constructor(codeType: string) {
            super({
                title: "Reason for Non-Feasible Preassignment",
                minWidth: "500",
                okVisible: false,
                borderShadow: true,
                fillHeight: false,
                fillRow: false,
                panelTitleProps: {
                    backgroundColor: "primary.darker",
                    maxHeight: 55,
                    fillRow: true,
                    paddingLeft: 0,
                    paddingRight: 8
                },
                titleProps: {
                    color: "default.reverse",
                    fontBold: true,
                    fontSize: "large",
                    rowBreak: false,
                    marginLeft: 16
                }
            });
    
            this._codeType = codeType;
            this.buttonClose.setProps({
                color: "primary.reverse"
            });
        }

    override async show(): Promise<any> {
        this.layout = Layout.getLayout("lme/dispatch/asset/PreassignmentPrompt") as PreassignmentPrompt;
        this.layout.addLayoutLoadListener(() => {
            this.layout.mainDataSource.mode = DataSourceMode.ADD;

            this.layout.textboxReasonCode.addBeforeLookupModelSearchListener((event) => {
                event.filter.code_type = this._codeType;
            });

            this.layout.buttonCancel.addClickListener(() => this.close(false));
            this.layout.buttonOK.addClickListener(() => {
                if (this.layout.mainDataSource.validate()) {
                    this.close(this.layout.activeRow);
                }
            });
        });

        this.add(this.layout);
        return super.show();
    }

}